var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-text',[_c('v-row',[_c('v-btn',{staticClass:"ml-2 float-right",attrs:{"color":"quaternary","dark":""}},[_vm._v("Download Report")])],1),_c('v-row',[_c('card-view-base',{attrs:{"item":_vm.item,"filter":_vm.filter,"cards":_vm.cards}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }